import React from 'react';
import { FiChevronUp, FiChevronDown } from 'react-icons/fi';
import { VISIT_TYPES, formatVisitId } from '../../utils/constants';
import { formatDateDDMMMYYYY } from '../../utils/dateFormat';

const SORT_KEYS = {
  visitId: 'displayVisitCode',
  site: 'siteCode',
  visitType: 'visitType',
  cra: 'craName',
  followUpConfirmedOn: 'followUpConfirmedOn',
  crfStage: 'crfStage',
};

const getField = (row, ...keys) => {
  for (const k of keys) {
    if (row[k] != null && row[k] !== '') return row[k];
  }
  return null;
};

const getVisitId = (row) =>
  getField(row, 'scheduledVisitID', 'ScheduledVisitID', 'scheduledVisitId');

const UnlockTransactionGrid = ({
  rows,
  loading,
  sortBy,
  sortOrder,
  onSort,
  onUnlock,
  emptyMessage = 'No fully completed visits eligible for unlock.',
}) => {
  const SortIcon = ({ column }) => {
    if (sortBy !== column) return null;
    return sortOrder === 'asc' ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />;
  };

  return (
    <div className="data-grid-table-wrapper table-responsive">
      <table className="visit-letter-table">
        <thead>
          <tr>
            <th>
              <button type="button" className="visit-letter-th-sort" onClick={() => onSort('visitId')}>
                Visit ID <SortIcon column="visitId" />
              </button>
            </th>
            <th>
              <button type="button" className="visit-letter-th-sort" onClick={() => onSort('site')}>
                Site <SortIcon column="site" />
              </button>
            </th>
            <th>
              <button type="button" className="visit-letter-th-sort" onClick={() => onSort('visitType')}>
                Visit Type <SortIcon column="visitType" />
              </button>
            </th>
            <th>
              <button type="button" className="visit-letter-th-sort" onClick={() => onSort('cra')}>
                CRA <SortIcon column="cra" />
              </button>
            </th>
            <th>
              <button type="button" className="visit-letter-th-sort" onClick={() => onSort('followUpConfirmedOn')}>
                Follow-Up Confirmed <SortIcon column="followUpConfirmedOn" />
              </button>
            </th>
            <th>
              <button type="button" className="visit-letter-th-sort" onClick={() => onSort('crfStage')}>
                Report Stage <SortIcon column="crfStage" />
              </button>
            </th>
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={7} className="empty-state">Loading visits…</td>
            </tr>
          ) : rows.length === 0 ? (
            <tr>
              <td colSpan={7} className="empty-state">{emptyMessage}</td>
            </tr>
          ) : (
            rows.map((row) => {
              const id = getVisitId(row);
              const visitIdDisplay = formatVisitId(row);
              const siteCode = getField(row, 'siteCode', 'SiteCode') ?? '—';
              const vt = getField(row, 'visitType', 'VisitType');
              const visitTypeLabel = VISIT_TYPES[vt] || vt || '—';
              const craName = getField(row, 'craName', 'CRAName') ?? '—';
              const confirmedOn = getField(row, 'followUpConfirmedOn', 'FollowUpConfirmedOn');
              const crfStage = getField(row, 'crfStage', 'CrfStage') ?? '—';

              return (
                <tr key={id}>
                  <td className="font-bold">{visitIdDisplay}</td>
                  <td>{siteCode}</td>
                  <td>{visitTypeLabel}</td>
                  <td>{craName}</td>
                  <td>{confirmedOn ? formatDateDDMMMYYYY(confirmedOn) : '—'}</td>
                  <td><span className="visit-letter-status">{crfStage}</span></td>
                  <td className="text-center visit-letter-actions">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={() => onUnlock(row)}
                      title="Unlock visit"
                    >
                      Unlock
                    </button>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export { SORT_KEYS };
export default UnlockTransactionGrid;
